export const MIN_TEXTAREA_HEIGHT_PX = 40;
export const MAX_TEXTAREA_HEIGHT_PX = 320;

export const clampTextareaHeight = (value: number): number =>
  Math.max(MIN_TEXTAREA_HEIGHT_PX, Math.min(MAX_TEXTAREA_HEIGHT_PX, value));

export const calculateDraggedTextareaHeight = (
  initialHeight: number,
  initialPointerY: number,
  currentPointerY: number
): number => {
  const deltaY = currentPointerY - initialPointerY;
  return clampTextareaHeight(initialHeight - deltaY);
};
